<template>
  <div class="station" :class="{'hover': hoverNo === index}" @click.prevent="clickAction">
    <span class="channel-position">{{ card.position }}</span>
    <div class="img-wrap" :style="{'backgroundImage': bgImage}"></div>
    <i>
      <svg xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 30 30"><path d="M14.997,30.001 C6.713,30.001 -0.003,23.284 -0.003,15.000 C-0.003,6.715 6.713,-0.001 14.997,-0.001 C23.282,-0.001 29.998,6.715 29.998,15.000 C29.998,23.284 23.282,30.001 14.997,30.001 ZM14.997,1.304 C7.433,1.304 1.301,7.436 1.301,15.000 C1.301,22.564 7.433,28.696 14.997,28.696 C22.561,28.696 28.693,22.564 28.693,15.000 C28.693,7.436 22.561,1.304 14.997,1.304 ZM11.073,22.694 C10.502,23.026 9.785,22.610 9.785,21.945 L9.785,8.038 C9.785,7.373 10.502,6.957 11.073,7.290 L23.039,14.243 C23.610,14.576 23.610,15.407 23.039,15.740 L11.073,22.694 Z"/></svg>
    </i>
  </div>
</template>

<script>
import { getRadioCardImagePath } from 'helpers/images'
import { getEonUrl } from 'helpers/baseURLhelper'
export default {
  name: 'Station',
  data: function () {
    return {
      isPlaying: false,
      processing: false
    }
  },
  props: {
    card: Object,
    hoverNo: {
      type: Number,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    bgImage: function () {
      return `url(${getRadioCardImagePath(this.card.images)})`
    }
    // isHazardousBrowser: function () {
    //   return this.$browserName === 'IE' ||
    //           this.$browserName === 'Edge' ||
    //           this.$browserName === 'Safari'
    // },
  },
  methods: {
    clickAction: function (e) {
      window.open(`${getEonUrl()}/guide/radio/${this.card.id}`, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
    @import 'uc/_variables';
    @import 'uc/_mixins';

    .station {
        padding: 0 5px;
        height: 8.4vw;
        box-shadow: 0 0 12px 5px rgba(0,0,0,.1);
        background-color: #fff;
        position: relative;
        cursor: pointer;
        margin-bottom: 2vw;
    }
    .img-wrap {
        width: 100%;
        padding: 28.125% 0;
        background-repeat: no-repeat;
        background-position: 50%;
        background-size: cover;
        position: relative;
    }
    i {
        width: 18px;
        height: 18px;
        position: absolute;
        top: 10px;
        right: 10px;
        opacity: 0;
        transition: opacity 0.3s ease;
            svg {
                width: 100%;
                height: 100%;
                fill: #979ea1;
                transition: fill 0.3s ease;
                cursor: pointer;
            }
            svg:hover {
                fill :#323e43;
            }
            svg use {
                pointer-events: none;
            }
    }
    .station.hover {
        i {
            opacity: 1;
        }
    }
    .channel-position {
        position: absolute;
        top: 5px;
        left: 6px;
        font-size: 12px;
        color: #828282;
    }

      // Animation
    .station {
      transition: transform 300ms;
      transform: scale(1);
    }
    .hover .station {
      transform: scale(1.23);
    }

    @media only screen and (max-width: $breakpoint1) {
        .station {
            height: 86px;
            margin-bottom: 20px;
        }
    }

    @media only screen and (min-width: $breakpoint2) {
        i {
            width: 24px;
            height: 24px;
        }
         .channel-position {
            top: 10px;
            left: 10px;
            font-size: 14px;
        }
    }

    @media only screen and (min-width: $breakpoint3) {
        .station {
            padding: 15px 25px;
        }
        i {
            width: 28px;
            height: 28px;
        }
    }

    @media only screen and (min-width: $breakpoint4) {
        .station {
            height: 168px;
            margin-bottom: 50px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/cards/Station.vue